<div fxLayout="row" fxLayoutAlign="center center">
  <mat-form-field fxFlex subscriptSizing="dynamic" appearance="outline">
    <mat-label>{{ placeholder }}</mat-label>
    <mat-icon matPrefix>search</mat-icon>
    <input matInput autocomplete="off" [formControl]="control">
  </mat-form-field>
</div>
